import { Injectable } from '@angular/core';
import { BehaviorSubject, ReplaySubject } from 'rxjs';
import { ExternalSettings } from 'src/app/common/services/external-settings/external-settings.interface';
import { ExternalSettingsService } from 'src/app/common/services/external-settings/external-settings.service';
import { PermissionList } from 'src/app/common/services/internal-settings/internal-settings.interface';
import { InternalSettingsService, hasOnePermission } from 'src/app/common/services/internal-settings/internal-settings.service';

@Injectable({
  providedIn: 'root'
})
export class SupportCenterService {

  public showSecureMessage$ : ReplaySubject<boolean> = new ReplaySubject<boolean>();
  public showResources$ : ReplaySubject<boolean> = new ReplaySubject<boolean>();
  public showHelpDesk$ : ReplaySubject<boolean> = new ReplaySubject<boolean>();
  public showTools$ : ReplaySubject<boolean> = new ReplaySubject<boolean>();
  public showLocation$ : BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  private isSecureMessageModuleEnabled : boolean = false;
  private isResourceModuleEnabled : boolean = false;
  private isHelpDeskModuleEnabled : boolean = false;
  private isToolsModuleEnabled : boolean = false;

  private hasSecureMessagePermission : boolean = false;
  private hasResourcePermission : boolean = false;
  private hasHelpDeskPermission : boolean = false;

  constructor(srvEs : ExternalSettingsService,
              srvIs : InternalSettingsService
  ) {

      this.showSecureMessage$.next(false);
      this.showHelpDesk$.next(false);
      this.showResources$.next(false);

      srvEs.externalSettings$.subscribe((es : ExternalSettings) => {
        this.isSecureMessageModuleEnabled = es.globalVariables.isModuleEnabledSecureMessage;
        this.isHelpDeskModuleEnabled = es.globalVariables.isModuleEnabledCustomerHelpDesk;
        this.isResourceModuleEnabled = es.globalVariables.isModuleEnabledMobibranchFileVault;
        this.isToolsModuleEnabled = es.globalVariables.isModuleEnabledMobibranchToolbox;
        this.showLocation$.next(es.globalVariables.isModuleEnabledLocations);

        if (!this.isSecureMessageModuleEnabled) {
          this.showSecureMessage$.next(false);
        }
      })    

      srvIs.internalSettings$.subscribe((is) => {
        if (is) {
          this.hasSecureMessagePermission = hasOnePermission([PermissionList.SECURE_MESSAGE], is.permissions);
          this.hasHelpDeskPermission = hasOnePermission([PermissionList.ACCESS_LIVE_CHAT], is.permissions);
          this.hasResourcePermission = hasOnePermission([PermissionList.ACCESS_RESOURCES], is.permissions);

          if (this.isSecureMessageModuleEnabled && this.hasSecureMessagePermission) {
            this.showSecureMessage$.next(true);
          }

          if (this.isHelpDeskModuleEnabled && this.hasHelpDeskPermission) {
            this.showHelpDesk$.next(true);
          }

          if (this.isResourceModuleEnabled && this.hasResourcePermission) {
            this.showResources$.next(true);
          }

          if (this.isToolsModuleEnabled) {
            this.showTools$.next(true);
          }
        }
      })
   }
}
